window["engagement-finder"] =  window['engagement-finder']  ||  {}
export default {
  name: "PublishedPage",
  components: {
    ...window["engagement-finder"].default
  },
  data: () => ({
    language: "fr"
  })
};